module.exports = __webpack_public_path__ + "img/magento-migration_medium.04d3e797.webp";